import React from 'react';

import { ProductDetailsModalContext } from '../../components/products/product-details/ProductDetailsModal';

export const useIsInProductDetailsModal = () => {
  return React.useContext(ProductDetailsModalContext).isInDetailsModal;
};
